import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth, Hub } from 'aws-amplify';
import { CommonDataService } from '@shared/services/common-data.service';
import { confirm, custom, alert } from 'devextreme/ui/dialog';
import { PreviewPdfService } from '@shared/services/preview-pdf.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
  uuid: any;
  checkForLog: boolean = true;
  fileName="";
  hideLoader:boolean = true;
  firstLogin: boolean = false;
  resMessage: any;
  constructor( 
    private router: Router,
    private zone: NgZone,
    private commonServices: CommonDataService, 
    private _preview: PreviewPdfService
  ) {
      this.hubInterface();
  }

  ngOnInit(): void {
    Auth.currentAuthenticatedUser()
    .then(() => {
      if(this.firstLogin || !this.checkForLog){
          this.commonServices.createAuthorizationToken().subscribe(r=>{
            if(r.status=="SUCCESS"){
              window.localStorage.setItem('cookieDetails', r.status);
              window.localStorage.setItem('cookieEndTimer', r.serviceResult.expiryEpochTime);
              window.localStorage.setItem('cookieStartTimer', r.serviceResult.issueAtEpochTime); 
              this.urlDownloadPDF();
            }
          }) 
      }else{
        const chkTimeCookie = window.localStorage.getItem('cookieDetails');
        if(chkTimeCookie){
          this.urlDownloadPDF();
        }else{
          window.localStorage.removeItem("mp-serve-auth");
          window.localStorage.removeItem("mpuserdetailslock");
          window.localStorage.removeItem("mpUInfo");
          window.localStorage.removeItem('cookieDetails');
          window.localStorage.removeItem('cookieStartTimer');
          window.localStorage.removeItem('cookieEndTimer');
          this.validateAndRedirect();
        }
      }
    }).catch((err) => {
      this.validateAndRedirect();
    })

    // this.login();
    
  }

  hubInterface(){
    Hub.listen('auth', (data) => {
      switch (data.payload.event) {
        case 'customOAuthState':
          let gedState = data.payload.data;
          if(gedState == "mpg"){
            this.firstLogin = !this.firstLogin;
          }else{
          this.uuid = data.payload.data;
          this.checkForLog = !this.checkForLog;
          this.downloadPDF(this.uuid);
          }
          break
      }
    });
  }

  downloadPDF(getUUID: any){
    
    this.commonServices.createAuthorizationToken().subscribe(r=>{
      
      if(r.status=="SUCCESS"){
        window.localStorage.setItem('cookieDetails', r.status);
        window.localStorage.setItem('cookieEndTimer', r.serviceResult.expiryEpochTime);
        window.localStorage.setItem('cookieStartTimer', r.serviceResult.issueAtEpochTime); 

        let id = this._preview.payloadList.length;
        this._preview.payloadList.push({
          payload: {"uuid": getUUID},
          url: environment.reportUrl + "/accessWeeklyPSR" , 
          fileName: '',
          checkResponseForFileName:true
        });
        window.localStorage.setItem("pdfPayload", JSON.stringify(this._preview.payloadList));
        window.open("preview-pdf/"+id.toString(), '_self');

        // this.commonServices.getDownload(getUUID).subscribe((res: any) => {
        //   const getName = res.headers.get('filename');
        //   if(getName !== null){
        //     if(getName.endsWith(".pdf")){
        //       let org:Blob = res.body as Blob;
        //       this.fileName = getName;
        //       // const blob: Blob = new Blob([org], {type: 'application/pdf'});
        //       const pdfUrl = window.URL.createObjectURL(org);
        //       window.open(pdfUrl, '_self');
        //       // const pdf = document.createElement('a');
        //       // pdf.href = pdfUrl;
        //       // pdf.download = getName;
        //       // pdf.download = res.headers.get('fileName').split(';')[1].split('filename')[1].split('=')[1].trim();
        //       // pdf.click();
        //       // this.customAlert("File has been downloaded Successfully.");
        //     }else{
        //       this.customAlert(getName);
        //     }
        //   }else{
        //     this.customAlert("File is not available to download.");
        //   }
        // }, (err) => {
        //   this.customAlert(err);
        // });
      }
    });

  }

  login(){
    if(this.checkForLog){
    this.commonServices.getUser().subscribe(r=>{
      if(r.status=="SUCCESS" && r.serviceResult.activeFlag && (r.serviceResult.userRole != null)){
          this.commonServices.fetchAllCommonData();
          this.commonServices.checkAuth.next(r.serviceResult.activeFlag);
          this.commonServices.userData.next(r.serviceResult.userRole.sectionPermissions);
          this.commonServices.userInfo.next(r.serviceResult);
          window.localStorage.setItem("mp-serve-auth", JSON.stringify(r.serviceResult.activeFlag));
          window.localStorage.setItem("mpuserdetailslock", JSON.stringify(r.serviceResult.userRole.sectionPermissions));
          window.localStorage.setItem("mpUInfo", JSON.stringify(r.serviceResult));
          this.zone.run(() => this.router.navigate(['/home'])); 
       
      }else if(r.serviceResult.userRole == null && this.checkForLog){
        // need to modify
        this.commonServices.getDisUser().subscribe(r=>{
          if(r.status=="SUCCESS" && r.serviceResult){
            this.resMessage = "Please wait, You will be re-directed to the Report page."
            this.downloadPDF(r.serviceResult);
          }else{
            this.router.navigate(['auth/unauthorized']);
          }
        });  
      }  
    }); 
  }
} 


  urlDownloadPDF(){
    const url = new URL(window.location.href);
    if(url.href.includes('download')) {
      const url = new URL(window.location.href);
      const parts = url.href.split('/');
      const lastPart = parts[parts.length - 1];
      const allLastParts = lastPart.split('=')
      const uuid = allLastParts[allLastParts.length - 1];
      if(uuid){
        this.downloadPDF(uuid);
      }
      }else{ 
        this.login();
      }
  }

  validateAndRedirect()  {
    
    const url = new URL(window.location.href);
      if(url.href.includes('download')) {
        const url = new URL(window.location.href);
        const parts = url.href.split('/');
        const lastPart = parts[parts.length - 1];
        const allLastParts = lastPart.split('=')
        const uuid = allLastParts[allLastParts.length - 1];
        //const uuid = uuidParam ? uuidParam : parts[parts.length - 2];
        const config = {
          //customProvider: 'Okta',
          customProvider: 'SiteMinder',
          customState: uuid,
        };
        this.fedaratedUI(config); 
      }
      else {
        const config = {
          //customProvider: 'Okta'
           customProvider: 'SiteMinder',
           customState: "mpg",
        };
        this.fedaratedUI(config); 
      } 
    
     
  }

  fedaratedUI(config: any){
    Auth.currentAuthenticatedUser()
    .then(() => {
      const chkTimeCookie = window.localStorage.getItem('cookieDetails');
        if(chkTimeCookie){
          this.login();
        }else{
          this.commonServices.createAuthorizationToken().subscribe(r=>{
            if(r.status=="SUCCESS"){
              window.localStorage.setItem('cookieDetails', r.status);
              window.localStorage.setItem('cookieEndTimer', r.serviceResult.expiryEpochTime);
              window.localStorage.setItem('cookieStartTimer', r.serviceResult.issueAtEpochTime); 
              this.login();
            }else{
              this.router.navigate(['auth/unauthorized']);
            }
          })
        }
      
    }).catch((err) => {
      console.log(err);
      Auth.federatedSignIn(config);
    })
  }

  // customAlert(message:any){
  //   this.hideLoader = !this.hideLoader;
  //   const mpDialog = custom({
  //     showTitle: false,
  //     messageHtml: message,
  //     buttons: [
  //       {
  //         text: "Signout and Close",
  //         onClick: (e) => {
  //           window.localStorage.removeItem("mp-serve-auth");
  //         window.localStorage.removeItem("mpuserdetailslock");
  //         window.localStorage.removeItem("mpUInfo");
  //         window.localStorage.removeItem('cookieDetails');
  //         window.localStorage.removeItem('cookieStartTimer');
  //         window.localStorage.removeItem('cookieEndTimer');
  //           Auth.signOut();
  //         }
  //       }
  //     ]
  //   });

  //   mpDialog.show().then((dialogResult:any) => {});
  // }




}
